export const getTimezoneAwareDateLabel = () => {
    const isUserBasedAbroad =
        Intl.DateTimeFormat().resolvedOptions().timeZone !== "Europe/London";

    if (isUserBasedAbroad) {
        return "(UK Standard Time)";
    }
    return "";
};
